// The $0 RMA watch's reads in the Activity Log (2026-11-02,
// docs/contact-view.md "Activity Log"): one line per watch, never a row per
// read. The sweep now saves one entry per watch that it updates (method
// WATCH, watchReads: the failed reads and the last 3); an older suggestion
// still holds a row for every read (getOrderById / getReasonCodeUsed
// "($0 RMA watch)"), which is folded here into the same kind of line, per
// step. Pure, so it is unit-testable.

import { zeroDollarWatchLine } from '@cxhub/shared'

export const WATCH_SHOWN_RECENT = 3

export function isWatchRead(call) {
  return /\(\$0 RMA watch\)$/.test(String(call?.label ?? ''))
}

export function isWatchSummary(call) {
  return call?.method === 'WATCH' && Array.isArray(call?.watchReads)
}

const timeOf = (c) => c?.startedAt ?? c?.at ?? null

// The line for an older suggestion's reads: the count of order reads, the
// time range only when the reads carry times (never a made-up one), and the
// last read's outcome when it failed.
function legacyLine(reads) {
  const orderReads = reads.filter((c) => /^getOrderById/.test(String(c?.label ?? '')))
  const times = reads.map(timeOf).filter(Boolean)
  const last = reads.at(-1)
  return zeroDollarWatchLine({
    reasonCode: null,
    count: orderReads.length,
    firstAt: times[0] ?? null,
    lastAt: times.at(-1) ?? null,
    last: last?.error ? `read failed (${last.error})` : null,
  })
}

// The Activity Log's API calls as shown: [{ kind: 'call', call }] and
// [{ kind: 'watch', entry, reads }] in their order. A watch's reads shown
// under its line: every failed read and the last WATCH_SHOWN_RECENT.
export function collapseWatchReads(calls) {
  const out = []
  const legacy = new Map()
  for (const c of calls ?? []) {
    if (isWatchSummary(c)) {
      out.push({ kind: 'watch', entry: c, reads: c.watchReads })
      continue
    }
    if (isWatchRead(c)) {
      const key = String(c?.stepIndex ?? '')
      let g = legacy.get(key)
      if (!g) {
        g = { kind: 'watch', legacy: true, all: [] }
        legacy.set(key, g)
        out.push(g)
      }
      g.all.push(c)
      continue
    }
    out.push({ kind: 'call', call: c })
  }
  for (const g of legacy.values()) {
    const recentFrom = Math.max(0, g.all.length - WATCH_SHOWN_RECENT)
    g.reads = g.all.filter((c, i) => c?.error || i >= recentFrom)
    g.entry = { service: 'CXHub', method: 'WATCH', label: legacyLine(g.all), source: g.all[0]?.source ?? null, phase: g.all[0]?.phase ?? null, actedBy: g.all[0]?.actedBy ?? null, watchCount: g.all.length }
    delete g.all
  }
  return out
}
